export const normalizeGameName = (value) => {
  if (value === null || value === undefined) return '';

  const cleaned = String(value)
    .trim()
    .toLowerCase()
    .replace(/[_\-\s]+/g, '');

  if (!cleaned) return '';
  if (cleaned.includes('roulette') || cleaned.includes('roulete')) return 'roulette';
  return cleaned;
};

export const dedupeBetHistory = (rows = []) => {
  const seen = new Set();

  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const key =
      row?.betId ??
      row?.id ??
      row?.transactionId ??
      row?.txId ??
      [
        row?.userId,
        row?.roundId,
        row?.gameId,
        row?.selection,
        row?.choice,
        row?.stake,
        row?.placedAt,
        row?.settledAt,
      ]
        .filter((value) => value !== undefined && value !== null && value !== '')
        .join('::');

    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const extractBetHistoryRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];

  for (const key of ['data', 'records', 'results', 'bets', 'items', 'rows']) {
    const value = payload[key];
    if (Array.isArray(value)) return value;
    if (value && typeof value === 'object') {
      const nestedRows = extractBetHistoryRows(value);
      if (nestedRows.length) return nestedRows;
    }
  }

  return [];
};

export const isRouletteBet = (row = {}) => {
  const normalizedGame = normalizeGameName(
    row.gameName ?? row.game_name ?? row.marketName ?? row.market_name ??
    row.game ?? row.tableName ?? row.table_name
  );
  const normalizedSelection = normalizeGameName(row.selection);
  const gameId = Number(
    row.gameId ?? row.gameID ?? row.gameid ?? row.game_id ??
    row.marketId ?? row.marketID ?? row.market_id ??
    row.casinoId ?? row.casino_id ?? row.tableId ?? row.table_id ?? 0
  );

  if (gameId === 3) return true;
  if (normalizedGame === 'roulette') return true;
  if (normalizedSelection === 'roulette') return true;

  return false;
};

export const normalizeCasinoBetHistoryRow = (row = {}) => ({
  ...row,
  id: row.id ?? row._id ?? row.betId ?? row.bet_id,
  marketId: row.roundId ?? row.roundID ?? row.round_id ?? row.marketId ?? row.market_id,
  marketName:
    row.gameName ?? row.game_name ?? row.game ?? row.gameType ?? row.game_type ??
    row.marketName ?? row.market_name ?? row.tableName ?? row.table_name,
  gameName:
    row.gameName ?? row.game_name ?? row.game ?? row.gameType ?? row.game_type ??
    row.marketName ?? row.market_name ?? row.tableName ?? row.table_name,
  rate: row.rate ?? row.odds ?? row.price ?? row.cashout,
  stake: row.stake ?? row.amount,
  betType: (row.betType ?? row.bet_type ?? row.side)?.toUpperCase(),
  backLay: (row.betType ?? row.bet_type ?? row.side)?.toUpperCase(),
  exposure: row.exposure ?? row.liability,
  pl: row.pl ?? row.profitLoss ?? row.profit_loss ?? row.pnl,
  result:
    row.outcome ?? row.result ?? row.winner ?? row.settledResult ?? row.settled_result,
  time:
    row.placedAt ?? row.placed_at ?? row.date ?? row.createdAt ?? row.created_at ??
    row.settledAt ?? row.settled_at ?? row.time ?? row.timestamp,
  ip: row.ipAddress ?? row.ip_address ?? row.clientIp ?? row.client_ip ?? row.ip,
});

export const filterRouletteBetHistory = (rows = []) =>
  dedupeBetHistory((Array.isArray(rows) ? rows : []).filter((row) => isRouletteBet(row)));
